
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class SKUSplittingAttributeDialog extends Serenity.PropertyDialog<any, any>
    {

        public form = new SKUSplittingAttributeForm(this.idPrefix);
        public option: string;
        public checksuccess: boolean;
        public AtbId: number;
        public selecteditem: any;
        public _checklist: ECommerce.OrderManagementCheckListRow[];
        constructor(options: any) {
            super();
            this.selecteditem = options.entity;
            this.form.ProductTypeId.value = this.selecteditem.ProductTypeId;
            this.form.CategoryId.value = this.selecteditem.CategoryId;
            this.form.SubCategoryId.value = this.selecteditem.SubCategoryId;
            this.form.BrandId.value = this.selecteditem.BrandId;
            this.form.CollectionId.value = this.selecteditem.CollectionId;
            this.form.SuperTypeId.value = this.selecteditem.SuperTypeId;
            this.form.Pieces.value = this.selecteditem.Pieces;
            this.form.Weight.value = this.selecteditem.Weight;
            this.form.NetWeight.value = this.selecteditem.NetWeight;


            this.form = new SKUSplittingAttributeForm(this.idPrefix);


            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.NewSKU);

            this.form.ProductTypeId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
            })

            this.form.SubCategoryId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.BrandId.changeSelect2(e => {
                this.checkAttribute();
            })
            this.form.CollectionId.changeSelect2(e => {
                this.checkAttribute();
            });
            this.form.SuperTypeId.changeSelect2(e => {
                this.checkAttribute();
            })
            this.form.NewSKU.changeSelect2(e => {
                var baseitemid = this.form.ProductTypeId.value == undefined ? 0 : this.form.ProductTypeId.value;
                var typeid = this.form.CategoryId.value == undefined ? 0 : this.form.CategoryId.value;
                var subtypeid = this.form.SubCategoryId.value == undefined ? 0 : this.form.SubCategoryId.value;
                var brandid = this.form.BrandId.value == undefined ? 0 : this.form.BrandId.value;
                var collectionid = this.form.CollectionId.value == undefined ? 0 : this.form.CollectionId.value;
                var supertypeid = this.form.SuperTypeId.value == undefined ? 0 : this.form.SuperTypeId.value;

                if (baseitemid == "" || typeid == "" || subtypeid == ""
                    || brandid == "" || collectionid == "" || supertypeid == "") {
                    Q.alert('All Attributes need to be selected');
                    this.form.NewSKU.value = 0;
                    return;
                }

                this.selecteditem.ProductTypeId = parseInt(baseitemid.toString());
                this.selecteditem.CategoryId = parseInt(typeid.toString());
                this.selecteditem.SubCategoryId = parseInt(subtypeid.toString());
                this.selecteditem.BrandId = parseInt(brandid.toString());
                this.selecteditem.CollectionId = parseInt(collectionid.toString());
                this.selecteditem.SuperTypeId = parseInt(supertypeid.toString());

                this.form.NewSKU.element.focus;
            });
        }


        checkAttribute() {
            var baseitemid = parseInt(this.form.ProductTypeId.value) == undefined ? 0 : parseInt(this.form.ProductTypeId.value);
            var typeid = parseInt(this.form.CategoryId.value) == undefined ? 0 : parseInt(this.form.CategoryId.value);
            var subtypeid = parseInt(this.form.SubCategoryId.value) == undefined ? 0 : parseInt( this.form.SubCategoryId.value);
            var brandid = parseInt(this.form.BrandId.value) == undefined ? 0 : parseInt(this.form.BrandId.value);
            var collectionid = parseInt(this.form.CollectionId.value )== undefined ? 0 : parseInt(this.form.CollectionId.value);
            var supertypeid = parseInt(this.form.SuperTypeId.value )== undefined ? 0 : parseInt(this.form.SuperTypeId.value);

            var attributeid;;
            OMS.CommonAttributesService.GetProductATB({
                ProductTypeId: (baseitemid),
                CategoryId: (typeid),
                SubCategoryId: (subtypeid),
                BrandId: (brandid),
                CollectionId: (collectionid),
                SuperTypeId: (supertypeid)

            }, response => {
                attributeid = response.AttributeId
            }, { async: false }
            );
            if (attributeid.length > 0) {
                this.AtbId = attributeid[0].AttributeId;
            }
            else {
                this.AtbId = 0;
            }

        }
        getDialogOptions() {
            var options = super.getDialogOptions();
            options.height = 270;
            options.width = 1000;
            return options;
        }
        protected getDialogTitle(): string {
            return "Split Item";
        }

        protected onDialogOpen() {
            super.onDialogOpen();

        }


        protected getDialogButtons() {
            return [
                {
                    text: 'Ok',
                    click: () => {
                        this.checkAttribute();
                        this.checksuccess = true;
                        this.dialogClose();

                    },
                },
                {
                    text: 'Cancel',
                    click: () => {
                        //this.checksuccess = false;
                        this.dialogClose();

                    }
                }
            ];
        }
    }
}